/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RackByIdPlaceResponse } from './rack-by-id-place-response';


export interface RackByIdShelfResponse { 
    id: string;
    name: string;
    number: number;
    socketTypeId: number;
    places?: Array<RackByIdPlaceResponse> | null;
}

